import { mode, transparentize } from "@chakra-ui/theme-tools";

function variantCount(props) {
    const { colorScheme: c, theme } = props;
    const dark = transparentize(`${c}.300`, 0.6)(theme);
    return {
        justifyContent: "center",
        bg: mode(dark, `${c}.500`)(props),
        color: mode("gray.700", "white")(props),
        borderRadius: "full",
        minWidth: 6,
        minHeight: 4
    };
}
function variantToC(props) {
    const { colorScheme: c, theme } = props;
    const dark = transparentize(`${c}.300`, 0.6)(theme);
    return {
        justifyContent: "center",
        bg: mode(dark, `${c}.500`)(props),
        color: mode("gray.700", "white")(props),
        borderRadius: "full",
        minWidth: 6,
        minHeight: 4
    };
}

export default {
    Tag: {
        baseStyle: {},
        sizes: {},
        variants: {
            count: props => ({
                container: variantCount(props),
            }),
            toc: props => ({
                container: variantToC(props),
            })
        },
        defaultProps: {},
    }
};
